import NavBar from "../Componentes/NavBar";
import { useModal } from "../contexts/ModalContext";
import ContentContainer from "../Modulos/ColaboradorV2/ContentContainer";

const ColaboradorV2 = () => {

    const { openModal } = useModal();

    return (
        <>
            <NavBar
                title="COLABORADOR"
                modulo="rh"
                setSideBar={() => openModal('sidebarColaborador')}
            />
            <ContentContainer />
        </>
    )
}

export default ColaboradorV2;
